var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#F5F8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2065 20.7125C13.9368 20.987 13.9223 21.4926 14.2162 21.7815C14.51 22.0752 15.0109 22.0656 15.2855 21.7911L18.0021 19.0753L20.7139 21.7863C20.9981 22.0752 21.4894 22.0704 21.7784 21.7767C22.0722 21.4877 22.0722 20.9966 21.788 20.7125L19.0762 18.0015L21.788 15.2857C22.0722 15.0016 22.0722 14.5104 21.7784 14.2215C21.4894 13.9278 20.9981 13.9278 20.7139 14.2119L18.0021 16.9229L15.2855 14.2071C15.0109 13.9374 14.5052 13.923 14.2162 14.2167C13.9272 14.5104 13.9368 15.0112 14.2065 15.2857L16.9232 18.0015L14.2065 20.7125Z",
    fill: "#2E3A59",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.51de281703ea7c3ed973d49029821505.svg";
export { ForwardRef as ReactComponent };